import React from 'react';

import ErrorIcon from '@mui/icons-material/Error';

import aampeTheme from '../../constants/aampeTheme';

import BaseSnackBar from '../snackBar/baseSnackBar';

interface ErrorSnackBarProps {
    title: string;
    autoHideDuration?: number;
    open?: boolean;
    handleClose?: () => void;
}

const ErrorSnackBar: React.FC<React.PropsWithChildren<ErrorSnackBarProps>> = ({
    title = 'An error occurred',
    autoHideDuration,
    open = true,
    handleClose,
}) => {
    return (
        <BaseSnackBar
            open={open}
            handleClose={handleClose}
            Icon={ErrorIcon}
            title={title}
            color={aampeTheme.colors.orange500}
            bgColor={aampeTheme.colors.error25}
            autoHideDuration={autoHideDuration}
        />
    );
};

export default ErrorSnackBar;
